import * as React from 'react'
import classNames from 'classnames'
import { matchesPathname } from '../../../utils'
import { navConfig, navLinks, navBaseClass } from '../nav.data'
import { NavLinkPaths } from '../nav.enums'
import { NavLinkPosition } from '../nav.types'
import './nav-desktop.scss'

export class NavDesktop extends React.Component {
  baseClass: string = navBaseClass

  getNavLinksForPosition(position: NavLinkPosition): JSX.Element[] {
    return navLinks
      .filter(navLink => navLink.desktopPosition === position)
      .map((navLink) => {
        const { className, name, path: href, clickHandler } = navLink
        const props: object = {
          className: classNames(
            className || `${this.baseClass}__link`,
            { [`${this.baseClass}__link--active`]: !className && matchesPathname(href) }
          ),
          key: name,
          href
        }
        return clickHandler ? <a {...props} onClick={clickHandler}>{name}</a> : <a {...props}>{name}</a>
      })
  }

  render(): React.ReactNode {
    return (
      <div className="container">
        <div className={`${this.baseClass} flex items--center justify--between`}>
          <div className="flex items--center justify--center">
            <a href={NavLinkPaths.ORDER}>
              <img src={navConfig.imgSrc} className={`${this.baseClass}__logo`} />
            </a>
            {this.getNavLinksForPosition('left')}
          </div>
          <div className="flex items--center justify--center">
            {this.getNavLinksForPosition('right')}
          </div>
        </div>
      </div>
    )
  }
}
